// extracted by mini-css-extract-plugin
export var animating = "_2r-3";
export var background = "_2r-6";
export var constrainHeight = "_2r-2";
export var dark = "_2r-4";
export var dropdown = "_2r-1";
export var leave = "_2r-5";
export var option = "_2r-7";
export var root = "_2r-0";